import { request } from './core';

export interface Client {
  ID: string;
  UserID: string;
  DisplayName: string;
  Email: string;
  Phone: string;
  Notes: string;
  IAMSubject: string;
  CreatedAt: string;
  UpdatedAt: string;
}

export interface ClientMessage {
  ID: string;
  ClientID: string;
  SenderKind: "photographer" | "client";
  SenderName: string;
  Body: string;
  CreatedAt: string;
}

export const clientsApi = {
  getClient: (id: string) => request<Client>("GET", `/api/v1/clients/${encodeURIComponent(id)}`),
  updateClient: (id: string, patch: { display_name?: string; email?: string; phone?: string; notes?: string }) =>
    request<Client>("PUT", `/api/v1/clients/${encodeURIComponent(id)}`, patch),
  listClients: () => request<Client[]>("GET", "/api/v1/clients"),
  createClient: (c: {
    DisplayName: string;
    Email?: string;
    Phone?: string;
    Notes?: string;
  }) =>
    request<Client>("POST", "/api/v1/clients", {
      display_name: c.DisplayName,
      email: c.Email ?? "",
      phone: c.Phone ?? "",
      notes: c.Notes ?? "",
    }),
  deleteClient: (id: string) => request<void>("DELETE", `/api/v1/clients/${id}`),
  generateClientToken: (clientId: string) =>
    request<{ token_url: string; expires_at: string }>("POST", `/api/v1/clients/${encodeURIComponent(clientId)}/access-token`, {}),
  revokeClientTokens: (clientId: string) =>
    request<void>("DELETE", `/api/v1/clients/${encodeURIComponent(clientId)}/access-tokens`),
  listClientMessages: (clientId: string) =>
    request<ClientMessage[]>("GET", `/api/v1/clients/${encodeURIComponent(clientId)}/messages`),
  sendClientMessage: (clientId: string, body: string) =>
    request<ClientMessage>("POST", `/api/v1/clients/${encodeURIComponent(clientId)}/messages`, { body }),
};
